import styled from "styled-components";
import { darken } from "polished";
import { calculateButtonColour, calculateButtonText } from "../../helpers/theme";
import { Button as ReactButton, Dropdown } from "react-bootstrap";

// TODO: I don't like using '!important' to force the style here but it keeps the colour correct when the toggle is active
// -- SO we should probably tidy this up and make it nicer...
export const StyledButtonSplitter = styled(Dropdown.Toggle)`
    z-index: ${(props: any) => props.zindex ?? 0} !important;
    color: ${(props: any) => calculateButtonText(props)} !important;
    background-color: ${(props: any) => calculateButtonColour(props)} !important;
    border-color: ${(props: any) => calculateButtonColour(props)} !important;

    &:hover,
    &:first-child:hover {
        color: ${(props: any) => calculateButtonText(props)} !important;
        background-color: ${(props: any) => darken(0.05, calculateButtonColour(props))} !important;
        border-color: ${(props: any) => darken(0.05, calculateButtonColour(props))} !important;
    }

    &:active,
    &:first-child:active {
        color: ${(props: any) => calculateButtonText(props)} !important;
        background-color: ${(props: any) => darken(0.05, calculateButtonColour(props))} !important;
        border-color: ${(props: any) => darken(0.05, calculateButtonColour(props))} !important;
    }

    &:focus,
    &:first-child:focus {
        color: ${(props: any) => calculateButtonText(props)} !important;
        background-color: ${(props: any) => darken(0.05, calculateButtonColour(props))} !important;
        border-color: ${(props: any) => darken(0.05, calculateButtonColour(props))} !important;
        box-shadow: unset;
    }
`;

const StyledButton = styled(ReactButton)`
    z-index: ${(props: any) => props.zindex ?? 0} !important;
    color: ${(props: any) => calculateButtonText(props)};
    background-color: ${(props: any) => calculateButtonColour(props)};
    border-color: ${(props: any) => calculateButtonColour(props)};

    &:hover,
    &:first-child:hover {
        color: ${(props: any) => calculateButtonText(props)};
        background-color: ${(props: any) => darken(0.05, calculateButtonColour(props))};
        border-color: ${(props: any) => darken(0.05, calculateButtonColour(props))};
    }

    &:active,
    &:first-child:active {
        color: ${(props: any) => calculateButtonText(props)};
        background-color: ${(props: any) => darken(0.05, calculateButtonColour(props))};
        border-color: ${(props: any) => darken(0.05, calculateButtonColour(props))};
    }

    &:focus,
    &:first-child:focus {
        color: ${(props: any) => calculateButtonText(props)};
        background-color: ${(props: any) => darken(0.05, calculateButtonColour(props))};
        border-color: ${(props: any) => darken(0.05, calculateButtonColour(props))};
        box-shadow: unset;
    }
`;

export default StyledButton;